var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export const waitForGlobal = (key, timeout, timeoutIdRef) => __awaiter(void 0, void 0, void 0, function* () {
    const helper = (resolve, reject) => {
        if (!!window[key]) {
            resolve();
        }
        else if (timeout && Date.now() - start > timeout) {
            reject(new Error(`Timed out waiting for 'window.${key}'`));
        }
        else {
            timeoutIdRef.current = setTimeout(() => helper(resolve, reject), 100);
        }
    };
    const start = Date.now();
    return new Promise(helper);
});
//# sourceMappingURL=utils.js.map